var map = {
	"./Alternate/acrobat.webp": 17810,
	"./Alternate/alchemist.webp": 66105,
	"./Alternate/alhadikhia.webp": 51014,
	"./Alternate/alsaahir.webp": 38215,
	"./Alternate/amnesiac.webp": 57835,
	"./Alternate/apprentice_e.webp": 51283,
	"./Alternate/apprentice_g.webp": 13287,
	"./Alternate/artist.webp": 3864,
	"./Alternate/assassin.webp": 55196,
	"./Alternate/atheist.webp": 27934,
	"./Alternate/balloonist.webp": 66953,
	"./Alternate/banshee.webp": 77451,
	"./Alternate/barber.webp": 71483,
	"./Alternate/barista_e.webp": 6101,
	"./Alternate/barista_g.webp": 14776,
	"./Alternate/baron.webp": 19464,
	"./Alternate/beggar_e.webp": 27592,
	"./Alternate/beggar_g.webp": 13819,
	"./Alternate/bishop_e.webp": 7595,
	"./Alternate/bishop_g.webp": 88819,
	"./Alternate/boffin.webp": 18813,
	"./Alternate/bonecollector_e.webp": 96642,
	"./Alternate/bonecollector_g.webp": 36375,
	"./Alternate/boomdandy.webp": 32355,
	"./Alternate/bountyhunter.webp": 30328,
	"./Alternate/bureaucrat_e.webp": 60920,
	"./Alternate/bureaucrat_g.webp": 43660,
	"./Alternate/butcher_e.webp": 62293,
	"./Alternate/butcher_g.webp": 44952,
	"./Alternate/butler.webp": 28362,
	"./Alternate/cacklejack_e.webp": 25771,
	"./Alternate/cacklejack_g.webp": 96243,
	"./Alternate/cannibal.webp": 74892,
	"./Alternate/cerenovus.webp": 78417,
	"./Alternate/chambermaid.webp": 45849,
	"./Alternate/chef.webp": 15858,
	"./Alternate/choirboy.webp": 94152,
	"./Alternate/clockmaker.webp": 75926,
	"./Alternate/courtier.webp": 42219,
	"./Alternate/cultleader.webp": 41509,
	"./Alternate/damsel.webp": 15530,
	"./Alternate/demon.webp": 61134,
	"./Alternate/deviant_e.webp": 42266,
	"./Alternate/deviant_g.webp": 30880,
	"./Alternate/devilsadvocate.webp": 28022,
	"./Alternate/dreamer.webp": 97216,
	"./Alternate/drunk.webp": 88141,
	"./Alternate/empath.webp": 84972,
	"./Alternate/engineer.webp": 44951,
	"./Alternate/eviltwin.webp": 67299,
	"./Alternate/exorcist.webp": 59794,
	"./Alternate/fanggu.webp": 84598,
	"./Alternate/farmer.webp": 43211,
	"./Alternate/fearmonger.webp": 84473,
	"./Alternate/fisherman.webp": 70413,
	"./Alternate/flowergirl.webp": 7415,
	"./Alternate/fool.webp": 55573,
	"./Alternate/fortuneteller.webp": 85604,
	"./Alternate/gambler.webp": 34043,
	"./Alternate/gangster_e.webp": 99627,
	"./Alternate/gangster_g.webp": 32962,
	"./Alternate/general.webp": 46325,
	"./Alternate/gnome_e.webp": 82716,
	"./Alternate/gnome_g.webp": 91679,
	"./Alternate/goblin.webp": 45444,
	"./Alternate/godfather.webp": 46555,
	"./Alternate/golem.webp": 4789,
	"./Alternate/goon.webp": 35939,
	"./Alternate/gossip.webp": 1983,
	"./Alternate/grandmother.webp": 35012,
	"./Alternate/gunslinger_e.webp": 64285,
	"./Alternate/gunslinger_g.webp": 92945,
	"./Alternate/harlot_e.webp": 41204,
	"./Alternate/harlot_g.webp": 9488,
	"./Alternate/harpy.webp": 58579,
	"./Alternate/hatter.webp": 80352,
	"./Alternate/heretic.webp": 84976,
	"./Alternate/hermit.webp": 39696,
	"./Alternate/highpriestess.webp": 83543,
	"./Alternate/huntsman.webp": 5996,
	"./Alternate/imp.webp": 69922,
	"./Alternate/innkeeper.webp": 8415,
	"./Alternate/investigator.webp": 6368,
	"./Alternate/judge_e.webp": 82809,
	"./Alternate/judge_g.webp": 62255,
	"./Alternate/juggler.webp": 71921,
	"./Alternate/kazali.webp": 80993,
	"./Alternate/king.webp": 89265,
	"./Alternate/klutz.webp": 97338,
	"./Alternate/knight.webp": 80915,
	"./Alternate/legion.webp": 8906,
	"./Alternate/leviathan.webp": 14877,
	"./Alternate/librarian.webp": 66411,
	"./Alternate/lilmonsta.webp": 18215,
	"./Alternate/lleech.webp": 60977,
	"./Alternate/lordoftyphon.webp": 42302,
	"./Alternate/lunatic.webp": 43481,
	"./Alternate/lycanthrope.webp": 10890,
	"./Alternate/magician.webp": 5274,
	"./Alternate/marionette.webp": 71745,
	"./Alternate/mastermind.webp": 35588,
	"./Alternate/mathematician.webp": 95732,
	"./Alternate/matron_e.webp": 61165,
	"./Alternate/matron_g.webp": 94112,
	"./Alternate/mayor.webp": 62133,
	"./Alternate/mezepheles.webp": 25106,
	"./Alternate/minion.webp": 84318,
	"./Alternate/minstrel.webp": 16649,
	"./Alternate/monk.webp": 19936,
	"./Alternate/moonchild.webp": 50680,
	"./Alternate/mutant.webp": 44122,
	"./Alternate/nightwatchman.webp": 20326,
	"./Alternate/noble.webp": 7454,
	"./Alternate/nodashii.webp": 39644,
	"./Alternate/ogre.webp": 27987,
	"./Alternate/ojo.webp": 92687,
	"./Alternate/oracle.webp": 71710,
	"./Alternate/organgrinder.webp": 61068,
	"./Alternate/outsider.webp": 23399,
	"./Alternate/pacifist.webp": 31199,
	"./Alternate/philosopher.webp": 13276,
	"./Alternate/pithag.webp": 79844,
	"./Alternate/pixie.webp": 79447,
	"./Alternate/plaguedoctor.webp": 84185,
	"./Alternate/po.webp": 63598,
	"./Alternate/poisoner.webp": 94087,
	"./Alternate/politician.webp": 33033,
	"./Alternate/poppygrower.webp": 31248,
	"./Alternate/preacher.webp": 28170,
	"./Alternate/princess.webp": 40185,
	"./Alternate/professor.webp": 53176,
	"./Alternate/psychopath.webp": 51017,
	"./Alternate/pukka.webp": 80629,
	"./Alternate/puzzlemaster.webp": 22270,
	"./Alternate/ravenkeeper.webp": 42536,
	"./Alternate/recluse.webp": 46320,
	"./Alternate/riot.webp": 86739,
	"./Alternate/sage.webp": 38201,
	"./Alternate/sailor.webp": 13620,
	"./Alternate/saint.webp": 54073,
	"./Alternate/savant.webp": 27122,
	"./Alternate/scapegoat_e.webp": 2615,
	"./Alternate/scapegoat_g.webp": 57398,
	"./Alternate/scarletwoman.webp": 73644,
	"./Alternate/seamstress.webp": 99931,
	"./Alternate/shabaloth.webp": 25273,
	"./Alternate/shugenja.webp": 48542,
	"./Alternate/slayer.webp": 48103,
	"./Alternate/snakecharmer.webp": 37876,
	"./Alternate/snitch.webp": 6398,
	"./Alternate/soldier.webp": 70529,
	"./Alternate/spy.webp": 24611,
	"./Alternate/steward.webp": 76096,
	"./Alternate/summoner.webp": 56022,
	"./Alternate/sweetheart.webp": 89058,
	"./Alternate/tealady.webp": 23157,
	"./Alternate/thief_e.webp": 64908,
	"./Alternate/thief_g.webp": 96868,
	"./Alternate/tinker.webp": 78876,
	"./Alternate/towncrier.webp": 86204,
	"./Alternate/townsfolk.webp": 36089,
	"./Alternate/traveller_e.webp": 7300,
	"./Alternate/traveller_g.webp": 49954,
	"./Alternate/undertaker.webp": 50124,
	"./Alternate/vigormortis.webp": 12800,
	"./Alternate/villageidiot.webp": 39104,
	"./Alternate/virgin.webp": 81880,
	"./Alternate/vizier.webp": 58882,
	"./Alternate/vortox.webp": 62630,
	"./Alternate/voudon_e.webp": 70804,
	"./Alternate/voudon_g.webp": 82208,
	"./Alternate/washerwoman.webp": 21658,
	"./Alternate/widow.webp": 72006,
	"./Alternate/witch.webp": 36181,
	"./Alternate/wizard.webp": 54858,
	"./Alternate/wraith.webp": 16472,
	"./Alternate/xaan.webp": 83969,
	"./Alternate/yaggababble.webp": 10650,
	"./Alternate/zealot.webp": 50452,
	"./Alternate/zombuul.webp": 45633,
	"./acrobat.webp": 9563,
	"./alchemist.webp": 26438,
	"./alhadikhia.webp": 70613,
	"./alsaahir.webp": 34016,
	"./amnesiac.webp": 30014,
	"./angel.webp": 75357,
	"./apprentice.webp": 42800,
	"./artist.webp": 9539,
	"./assassin.webp": 2520,
	"./atheist.webp": 43030,
	"./balloonist.webp": 40573,
	"./banshee.webp": 25968,
	"./barber.webp": 79260,
	"./barista.webp": 8067,
	"./baron.webp": 58978,
	"./beggar.webp": 31067,
	"./bigwig.webp": 24641,
	"./bishop.webp": 56909,
	"./boffin.webp": 282,
	"./bonecollector.webp": 50141,
	"./boomdandy.webp": 92566,
	"./bootlegger.webp": 45716,
	"./bountyhunter.webp": 95134,
	"./buddhist.webp": 64392,
	"./bureaucrat.webp": 21968,
	"./butcher.webp": 91258,
	"./butler.webp": 82189,
	"./cacklejack.webp": 38717,
	"./cannibal.webp": 41785,
	"./cerenovus.webp": 74958,
	"./chambermaid.webp": 64281,
	"./chef.webp": 14706,
	"./choirboy.webp": 43008,
	"./clockmaker.webp": 96548,
	"./courtier.webp": 91858,
	"./cultleader.webp": 78962,
	"./damsel.webp": 41031,
	"./demon.webp": 72021,
	"./deusexfiasco.webp": 81965,
	"./deviant.webp": 38280,
	"./devilsadvocate.webp": 31018,
	"./djinn.webp": 9279,
	"./doomsayer.webp": 93174,
	"./dreamer.webp": 8646,
	"./drunk.webp": 63440,
	"./duchess.webp": 35584,
	"./empath.webp": 2716,
	"./engineer.webp": 85071,
	"./evil.webp": 33176,
	"./eviltwin.webp": 72517,
	"./exorcist.webp": 85174,
	"./fabled.webp": 80293,
	"./fanggu.webp": 18693,
	"./farmer.webp": 4708,
	"./fearmonger.webp": 61334,
	"./ferryman.webp": 85176,
	"./fibbin.webp": 7783,
	"./fiddler.webp": 30926,
	"./fisherman.webp": 64893,
	"./flowergirl.webp": 30481,
	"./fool.webp": 54158,
	"./fortuneteller.webp": 49826,
	"./gambler.webp": 36955,
	"./gangster.webp": 53008,
	"./gardener.webp": 1109,
	"./general.webp": 55779,
	"./gnome.webp": 96562,
	"./goblin.webp": 76246,
	"./godfather.webp": 63067,
	"./golem.webp": 86606,
	"./good.webp": 24917,
	"./goon.webp": 62723,
	"./gossip.webp": 61932,
	"./grandmother.webp": 29056,
	"./gunslinger.webp": 57480,
	"./harlot.webp": 83795,
	"./harpy.webp": 11890,
	"./hatter.webp": 74384,
	"./hellslibrarian.webp": 40757,
	"./heretic.webp": 55590,
	"./hermit.webp": 26621,
	"./highpriestess.webp": 89492,
	"./hindu.webp": 95121,
	"./huntsman.webp": 15617,
	"./imp.webp": 29692,
	"./innkeeper.webp": 40759,
	"./investigator.webp": 99506,
	"./judge.webp": 78797,
	"./juggler.webp": 30958,
	"./kazali.webp": 26774,
	"./king.webp": 35073,
	"./klutz.webp": 89559,
	"./knight.webp": 36615,
	"./legion.webp": 62484,
	"./leviathan.webp": 79859,
	"./librarian.webp": 2280,
	"./lilmonsta.webp": 62776,
	"./lleech.webp": 18579,
	"./lordoftyphon.webp": 85987,
	"./loric.webp": 43369,
	"./lunatic.webp": 46974,
	"./lycanthrope.webp": 30861,
	"./magician.webp": 51564,
	"./marionette.webp": 96230,
	"./mastermind.webp": 44629,
	"./mathematician.webp": 59185,
	"./matron.webp": 72069,
	"./mayor.webp": 67214,
	"./mezepheles.webp": 93225,
	"./minion.webp": 984,
	"./minstrel.webp": 21642,
	"./monk.webp": 43437,
	"./moonchild.webp": 77140,
	"./mutant.webp": 16146,
	"./nightwatchman.webp": 9683,
	"./noble.webp": 85920,
	"./nodashii.webp": 17772,
	"./official/bmr/apprentice.webp": 75658,
	"./official/bmr/apprentice_e.webp": 38105,
	"./official/bmr/apprentice_g.webp": 9589,
	"./official/bmr/assassin_e.webp": 82060,
	"./official/bmr/assassin_g.webp": 43881,
	"./official/bmr/bishop.webp": 95888,
	"./official/bmr/bishop_e.webp": 21946,
	"./official/bmr/bishop_g.webp": 98861,
	"./official/bmr/chambermaid_e.webp": 77120,
	"./official/bmr/chambermaid_g.webp": 86576,
	"./official/bmr/courtier_e.webp": 43134,
	"./official/bmr/courtier_g.webp": 62813,
	"./official/bmr/devilsadvocate_e.webp": 21939,
	"./official/bmr/devilsadvocate_g.webp": 76145,
	"./official/bmr/exorcist_e.webp": 55761,
	"./official/bmr/exorcist_g.webp": 40734,
	"./official/bmr/fool_e.webp": 98438,
	"./official/bmr/fool_g.webp": 91610,
	"./official/bmr/gambler_e.webp": 92731,
	"./official/bmr/gambler_g.webp": 62966,
	"./official/bmr/godfather_e.webp": 64885,
	"./official/bmr/godfather_g.webp": 40306,
	"./official/bmr/goon_e.webp": 16657,
	"./official/bmr/goon_g.webp": 73695,
	"./official/bmr/gossip_e.webp": 91419,
	"./official/bmr/gossip_g.webp": 95389,
	"./official/bmr/grandmother_e.webp": 97949,
	"./official/bmr/grandmother_g.webp": 46593,
	"./official/bmr/innkeeper_e.webp": 17571,
	"./official/bmr/innkeeper_g.webp": 98233,
	"./official/bmr/judge.webp": 10809,
	"./official/bmr/judge_e.webp": 96004,
	"./official/bmr/judge_g.webp": 52977,
	"./official/bmr/lunatic_e.webp": 30864,
	"./official/bmr/lunatic_g.webp": 20597,
	"./official/bmr/mastermind_e.webp": 97665,
	"./official/bmr/mastermind_g.webp": 10501,
	"./official/bmr/matron.webp": 56581,
	"./official/bmr/matron_e.webp": 78512,
	"./official/bmr/matron_g.webp": 39452,
	"./official/bmr/minstrel_e.webp": 58851,
	"./official/bmr/minstrel_g.webp": 36159,
	"./official/bmr/moonchild_e.webp": 72107,
	"./official/bmr/moonchild_g.webp": 1045,
	"./official/bmr/pacifist_e.webp": 78837,
	"./official/bmr/pacifist_g.webp": 20521,
	"./official/bmr/po_e.webp": 95106,
	"./official/bmr/po_g.webp": 62806,
	"./official/bmr/professor_e.webp": 1975,
	"./official/bmr/professor_g.webp": 11962,
	"./official/bmr/pukka_e.webp": 9950,
	"./official/bmr/pukka_g.webp": 88665,
	"./official/bmr/sailor_e.webp": 94138,
	"./official/bmr/sailor_g.webp": 65352,
	"./official/bmr/shabaloth_e.webp": 55212,
	"./official/bmr/shabaloth_g.webp": 14155,
	"./official/bmr/tealady_e.webp": 77601,
	"./official/bmr/tealady_g.webp": 59326,
	"./official/bmr/tinker_e.webp": 86657,
	"./official/bmr/tinker_g.webp": 48118,
	"./official/bmr/voudon.webp": 85405,
	"./official/bmr/voudon_e.webp": 70168,
	"./official/bmr/voudon_g.webp": 12454,
	"./official/bmr/zombuul_e.webp": 85973,
	"./official/bmr/zombuul_g.webp": 68127,
	"./official/carousel/acrobat_e.webp": 48662,
	"./official/carousel/acrobat_g.webp": 99335,
	"./official/carousel/alchemist_e.webp": 73454,
	"./official/carousel/alchemist_g.webp": 68584,
	"./official/carousel/alhadikhia_e.webp": 76220,
	"./official/carousel/alhadikhia_g.webp": 32704,
	"./official/carousel/alsaahir_e.webp": 38378,
	"./official/carousel/alsaahir_g.webp": 45103,
	"./official/carousel/amnesiac_e.webp": 94828,
	"./official/carousel/amnesiac_g.webp": 9700,
	"./official/carousel/atheist_e.webp": 10961,
	"./official/carousel/atheist_g.webp": 7570,
	"./official/carousel/balloonist_e.webp": 49510,
	"./official/carousel/balloonist_g.webp": 81677,
	"./official/carousel/banshee_e.webp": 99497,
	"./official/carousel/banshee_g.webp": 99974,
	"./official/carousel/boffin_e.webp": 75394,
	"./official/carousel/boffin_g.webp": 71631,
	"./official/carousel/boomdandy_e.webp": 44373,
	"./official/carousel/boomdandy_g.webp": 67744,
	"./official/carousel/bountyhunter_e.webp": 40994,
	"./official/carousel/bountyhunter_g.webp": 17400,
	"./official/carousel/cacklejack.webp": 25346,
	"./official/carousel/cacklejack_e.webp": 80050,
	"./official/carousel/cacklejack_g.webp": 56555,
	"./official/carousel/cannibal_e.webp": 95180,
	"./official/carousel/cannibal_g.webp": 11931,
	"./official/carousel/choirboy_e.webp": 10167,
	"./official/carousel/choirboy_g.webp": 31166,
	"./official/carousel/cultleader_e.webp": 21592,
	"./official/carousel/cultleader_g.webp": 49850,
	"./official/carousel/damsel_e.webp": 99029,
	"./official/carousel/damsel_g.webp": 9541,
	"./official/carousel/deusexfiasco.webp": 77410,
	"./official/carousel/engineer_e.webp": 46887,
	"./official/carousel/engineer_g.webp": 82625,
	"./official/carousel/farmer_e.webp": 27411,
	"./official/carousel/farmer_g.webp": 72141,
	"./official/carousel/fearmonger_e.webp": 78824,
	"./official/carousel/fearmonger_g.webp": 43145,
	"./official/carousel/ferryman.webp": 35861,
	"./official/carousel/fisherman_e.webp": 21331,
	"./official/carousel/fisherman_g.webp": 66110,
	"./official/carousel/gangster.webp": 39414,
	"./official/carousel/gangster_e.webp": 38426,
	"./official/carousel/gangster_g.webp": 59277,
	"./official/carousel/general_e.webp": 8216,
	"./official/carousel/general_g.webp": 81520,
	"./official/carousel/gnome.webp": 7312,
	"./official/carousel/gnome_e.webp": 16310,
	"./official/carousel/gnome_g.webp": 88726,
	"./official/carousel/goblin_e.webp": 41766,
	"./official/carousel/goblin_g.webp": 82848,
	"./official/carousel/golem_e.webp": 2074,
	"./official/carousel/golem_g.webp": 33710,
	"./official/carousel/harpy_e.webp": 41776,
	"./official/carousel/harpy_g.webp": 95554,
	"./official/carousel/hatter_e.webp": 38515,
	"./official/carousel/hatter_g.webp": 99648,
	"./official/carousel/heretic_e.webp": 91789,
	"./official/carousel/heretic_g.webp": 44847,
	"./official/carousel/hermit_e.webp": 98871,
	"./official/carousel/hermit_g.webp": 63649,
	"./official/carousel/highpriestess_e.webp": 26055,
	"./official/carousel/highpriestess_g.webp": 52852,
	"./official/carousel/huntsman_e.webp": 9765,
	"./official/carousel/huntsman_g.webp": 36643,
	"./official/carousel/kazali_e.webp": 68682,
	"./official/carousel/kazali_g.webp": 76223,
	"./official/carousel/king_e.webp": 25416,
	"./official/carousel/king_g.webp": 79440,
	"./official/carousel/knight_e.webp": 11111,
	"./official/carousel/knight_g.webp": 49016,
	"./official/carousel/legion_e.webp": 72367,
	"./official/carousel/legion_g.webp": 86120,
	"./official/carousel/leviathan_e.webp": 31754,
	"./official/carousel/leviathan_g.webp": 12140,
	"./official/carousel/lilmonsta_e.webp": 89115,
	"./official/carousel/lilmonsta_g.webp": 86219,
	"./official/carousel/lleech_e.webp": 82541,
	"./official/carousel/lleech_g.webp": 13661,
	"./official/carousel/lordoftyphon_e.webp": 37426,
	"./official/carousel/lordoftyphon_g.webp": 23430,
	"./official/carousel/lycanthrope_e.webp": 24151,
	"./official/carousel/lycanthrope_g.webp": 14195,
	"./official/carousel/magician_e.webp": 3007,
	"./official/carousel/magician_g.webp": 38352,
	"./official/carousel/marionette_e.webp": 84289,
	"./official/carousel/marionette_g.webp": 52634,
	"./official/carousel/mezepheles_e.webp": 39459,
	"./official/carousel/mezepheles_g.webp": 94326,
	"./official/carousel/nightwatchman_e.webp": 74439,
	"./official/carousel/nightwatchman_g.webp": 9310,
	"./official/carousel/noble_e.webp": 95867,
	"./official/carousel/noble_g.webp": 6895,
	"./official/carousel/ogre_e.webp": 10800,
	"./official/carousel/ogre_g.webp": 28150,
	"./official/carousel/ojo_e.webp": 25258,
	"./official/carousel/ojo_g.webp": 45578,
	"./official/carousel/organgrinder_e.webp": 32745,
	"./official/carousel/organgrinder_g.webp": 41108,
	"./official/carousel/pixie_e.webp": 93160,
	"./official/carousel/pixie_g.webp": 98277,
	"./official/carousel/plaguedoctor_e.webp": 92636,
	"./official/carousel/plaguedoctor_g.webp": 11348,
	"./official/carousel/politician_e.webp": 66835,
	"./official/carousel/politician_g.webp": 68803,
	"./official/carousel/poppygrower_e.webp": 34062,
	"./official/carousel/poppygrower_g.webp": 14193,
	"./official/carousel/preacher_e.webp": 94655,
	"./official/carousel/preacher_g.webp": 88218,
	"./official/carousel/princess_e.webp": 7644,
	"./official/carousel/princess_g.webp": 18104,
	"./official/carousel/psychopath_e.webp": 34456,
	"./official/carousel/psychopath_g.webp": 68297,
	"./official/carousel/puzzlemaster_e.webp": 90038,
	"./official/carousel/puzzlemaster_g.webp": 65439,
	"./official/carousel/riot_e.webp": 52735,
	"./official/carousel/riot_g.webp": 97492,
	"./official/carousel/shugenja_e.webp": 96482,
	"./official/carousel/shugenja_g.webp": 69778,
	"./official/carousel/snitch_e.webp": 76561,
	"./official/carousel/snitch_g.webp": 28298,
	"./official/carousel/steward_e.webp": 59482,
	"./official/carousel/steward_g.webp": 65314,
	"./official/carousel/summoner_e.webp": 31418,
	"./official/carousel/summoner_g.webp": 81375,
	"./official/carousel/villageidiot_e.webp": 65119,
	"./official/carousel/villageidiot_g.webp": 77391,
	"./official/carousel/vizier_e.webp": 89211,
	"./official/carousel/vizier_g.webp": 80726,
	"./official/carousel/widow_e.webp": 50392,
	"./official/carousel/widow_g.webp": 32375,
	"./official/carousel/wizard_e.webp": 66160,
	"./official/carousel/wizard_g.webp": 90171,
	"./official/carousel/wraith_e.webp": 50768,
	"./official/carousel/wraith_g.webp": 80995,
	"./official/carousel/xaan_e.webp": 81268,
	"./official/carousel/xaan_g.webp": 9108,
	"./official/carousel/yaggababble_e.webp": 95053,
	"./official/carousel/yaggababble_g.webp": 43580,
	"./official/carousel/zealot_e.webp": 71915,
	"./official/carousel/zealot_g.webp": 62436,
	"./official/fabled/angel.webp": 20793,
	"./official/fabled/buddhist.webp": 17852,
	"./official/fabled/djinn.webp": 21044,
	"./official/fabled/doomsayer.webp": 81334,
	"./official/fabled/duchess.webp": 25268,
	"./official/fabled/fibbin.webp": 6713,
	"./official/fabled/fiddler.webp": 19946,
	"./official/fabled/hellslibrarian.webp": 7707,
	"./official/fabled/revolutionary.webp": 51570,
	"./official/fabled/sentinel.webp": 95892,
	"./official/fabled/spiritofivory.webp": 40996,
	"./official/fabled/toymaker.webp": 44380,
	"./official/generic/custom.webp": 96148,
	"./official/generic/custom_e.webp": 50359,
	"./official/generic/custom_g.webp": 74938,
	"./official/generic/demon.webp": 87357,
	"./official/generic/demon_e.webp": 16799,
	"./official/generic/demon_g.webp": 63442,
	"./official/generic/evil.webp": 71535,
	"./official/generic/fabled.webp": 91243,
	"./official/generic/good.webp": 50838,
	"./official/generic/loric.webp": 38323,
	"./official/generic/minion.webp": 33321,
	"./official/generic/minion_e.webp": 37693,
	"./official/generic/minion_g.webp": 89999,
	"./official/generic/outsider.webp": 6523,
	"./official/generic/outsider_e.webp": 87623,
	"./official/generic/outsider_g.webp": 11901,
	"./official/generic/townsfolk.webp": 28116,
	"./official/generic/townsfolk_e.webp": 73315,
	"./official/generic/townsfolk_g.webp": 27198,
	"./official/generic/traveller.webp": 98993,
	"./official/generic/traveller_e.webp": 30665,
	"./official/generic/traveller_g.webp": 70095,
	"./official/loric/bigwig.webp": 17327,
	"./official/loric/bootlegger.webp": 33436,
	"./official/loric/gardener.webp": 27643,
	"./official/loric/godofug.webp": 92245,
	"./official/loric/hindu.webp": 96794,
	"./official/loric/knaves.webp": 94732,
	"./official/loric/pope.webp": 62905,
	"./official/loric/stormcatcher.webp": 38665,
	"./official/loric/tor.webp": 58404,
	"./official/loric/ventriloquist.webp": 15435,
	"./official/loric/zenomancer.webp": 7168,
	"./official/snv/artist_e.webp": 40261,
	"./official/snv/artist_g.webp": 98090,
	"./official/snv/barber_e.webp": 68855,
	"./official/snv/barber_g.webp": 34245,
	"./official/snv/barista.webp": 99705,
	"./official/snv/barista_e.webp": 84056,
	"./official/snv/barista_g.webp": 92750,
	"./official/snv/bonecollector.webp": 26123,
	"./official/snv/bonecollector_e.webp": 94803,
	"./official/snv/bonecollector_g.webp": 86476,
	"./official/snv/butcher.webp": 45053,
	"./official/snv/butcher_e.webp": 43797,
	"./official/snv/butcher_g.webp": 85313,
	"./official/snv/cerenovus_e.webp": 40855,
	"./official/snv/cerenovus_g.webp": 75718,
	"./official/snv/clockmaker_e.webp": 96435,
	"./official/snv/clockmaker_g.webp": 53512,
	"./official/snv/deviant.webp": 59164,
	"./official/snv/deviant_e.webp": 60849,
	"./official/snv/deviant_g.webp": 68451,
	"./official/snv/dreamer_e.webp": 20309,
	"./official/snv/dreamer_g.webp": 43791,
	"./official/snv/eviltwin_e.webp": 53380,
	"./official/snv/eviltwin_g.webp": 4341,
	"./official/snv/fanggu_e.webp": 15149,
	"./official/snv/fanggu_g.webp": 79635,
	"./official/snv/flowergirl_e.webp": 74084,
	"./official/snv/flowergirl_g.webp": 62506,
	"./official/snv/harlot.webp": 56544,
	"./official/snv/harlot_e.webp": 91673,
	"./official/snv/harlot_g.webp": 49366,
	"./official/snv/juggler_e.webp": 67351,
	"./official/snv/juggler_g.webp": 97506,
	"./official/snv/klutz_e.webp": 83010,
	"./official/snv/klutz_g.webp": 98487,
	"./official/snv/mathematician_e.webp": 67654,
	"./official/snv/mathematician_g.webp": 40978,
	"./official/snv/mutant_e.webp": 59543,
	"./official/snv/mutant_g.webp": 39305,
	"./official/snv/nodashii_e.webp": 78815,
	"./official/snv/nodashii_g.webp": 37123,
	"./official/snv/oracle_e.webp": 54419,
	"./official/snv/oracle_g.webp": 4632,
	"./official/snv/philosopher_e.webp": 3039,
	"./official/snv/philosopher_g.webp": 7307,
	"./official/snv/pithag_e.webp": 78259,
	"./official/snv/pithag_g.webp": 98050,
	"./official/snv/sage_e.webp": 78338,
	"./official/snv/sage_g.webp": 90193,
	"./official/snv/savant_e.webp": 40949,
	"./official/snv/savant_g.webp": 23941,
	"./official/snv/seamstress_e.webp": 23292,
	"./official/snv/seamstress_g.webp": 89638,
	"./official/snv/snakecharmer_e.webp": 39400,
	"./official/snv/snakecharmer_g.webp": 26217,
	"./official/snv/sweetheart_e.webp": 2731,
	"./official/snv/sweetheart_g.webp": 13498,
	"./official/snv/towncrier_e.webp": 85840,
	"./official/snv/towncrier_g.webp": 19090,
	"./official/snv/vigormortis_e.webp": 26830,
	"./official/snv/vigormortis_g.webp": 26685,
	"./official/snv/vortox_e.webp": 34524,
	"./official/snv/vortox_g.webp": 43192,
	"./official/snv/witch_e.webp": 50611,
	"./official/snv/witch_g.webp": 79942,
	"./official/tb/baron_e.webp": 88005,
	"./official/tb/baron_g.webp": 51488,
	"./official/tb/beggar.webp": 94449,
	"./official/tb/beggar_e.webp": 76595,
	"./official/tb/beggar_g.webp": 65449,
	"./official/tb/bureaucrat.webp": 90835,
	"./official/tb/bureaucrat_e.webp": 47139,
	"./official/tb/bureaucrat_g.webp": 1340,
	"./official/tb/butler_e.webp": 36509,
	"./official/tb/butler_g.webp": 90089,
	"./official/tb/chef_e.webp": 97837,
	"./official/tb/chef_g.webp": 17013,
	"./official/tb/drunk_e.webp": 71540,
	"./official/tb/drunk_g.webp": 70495,
	"./official/tb/empath_e.webp": 26966,
	"./official/tb/empath_g.webp": 92378,
	"./official/tb/fortuneteller_e.webp": 26015,
	"./official/tb/fortuneteller_g.webp": 14226,
	"./official/tb/gunslinger.webp": 64621,
	"./official/tb/gunslinger_e.webp": 64795,
	"./official/tb/gunslinger_g.webp": 15687,
	"./official/tb/imp_e.webp": 73546,
	"./official/tb/imp_g.webp": 28979,
	"./official/tb/investigator_e.webp": 58378,
	"./official/tb/investigator_g.webp": 17660,
	"./official/tb/librarian_e.webp": 70850,
	"./official/tb/librarian_g.webp": 31007,
	"./official/tb/mayor_e.webp": 71486,
	"./official/tb/mayor_g.webp": 35770,
	"./official/tb/monk_e.webp": 46217,
	"./official/tb/monk_g.webp": 65987,
	"./official/tb/poisoner_e.webp": 96094,
	"./official/tb/poisoner_g.webp": 11447,
	"./official/tb/ravenkeeper_e.webp": 232,
	"./official/tb/ravenkeeper_g.webp": 5014,
	"./official/tb/recluse_e.webp": 31131,
	"./official/tb/recluse_g.webp": 13553,
	"./official/tb/saint_e.webp": 30380,
	"./official/tb/saint_g.webp": 51431,
	"./official/tb/scapegoat.webp": 40619,
	"./official/tb/scapegoat_e.webp": 51707,
	"./official/tb/scapegoat_g.webp": 98041,
	"./official/tb/scarletwoman_e.webp": 47939,
	"./official/tb/scarletwoman_g.webp": 76637,
	"./official/tb/slayer_e.webp": 71519,
	"./official/tb/slayer_g.webp": 25873,
	"./official/tb/soldier_e.webp": 68322,
	"./official/tb/soldier_g.webp": 18189,
	"./official/tb/spy_e.webp": 49085,
	"./official/tb/spy_g.webp": 72200,
	"./official/tb/thief.webp": 6293,
	"./official/tb/thief_e.webp": 76358,
	"./official/tb/thief_g.webp": 17944,
	"./official/tb/undertaker_e.webp": 76045,
	"./official/tb/undertaker_g.webp": 80130,
	"./official/tb/virgin_e.webp": 1402,
	"./official/tb/virgin_g.webp": 85272,
	"./official/tb/washerwoman_e.webp": 88426,
	"./official/tb/washerwoman_g.webp": 40801,
	"./ogre.webp": 30704,
	"./ojo.webp": 20446,
	"./oracle.webp": 97905,
	"./organgrinder.webp": 32479,
	"./outsider.webp": 31936,
	"./pacifist.webp": 6715,
	"./philosopher.webp": 34349,
	"./pithag.webp": 66012,
	"./pixie.webp": 32120,
	"./plaguedoctor.webp": 32746,
	"./po.webp": 57441,
	"./poisoner.webp": 73009,
	"./politician.webp": 65558,
	"./pope.webp": 11937,
	"./poppygrower.webp": 53058,
	"./preacher.webp": 38497,
	"./princess.webp": 40710,
	"./professor.webp": 7249,
	"./psychopath.webp": 11132,
	"./pukka.webp": 2950,
	"./puzzlemaster.webp": 51913,
	"./ravenkeeper.webp": 68486,
	"./recluse.webp": 69192,
	"./revolutionary.webp": 96069,
	"./riot.webp": 50160,
	"./sage.webp": 52979,
	"./sailor.webp": 62762,
	"./saint.webp": 65417,
	"./savant.webp": 78931,
	"./scapegoat.webp": 68641,
	"./scarletwoman.webp": 94764,
	"./seamstress.webp": 55778,
	"./sentinel.webp": 99480,
	"./shabaloth.webp": 83893,
	"./shugenja.webp": 34360,
	"./slayer.webp": 28405,
	"./snakecharmer.webp": 57903,
	"./snitch.webp": 68139,
	"./soldier.webp": 379,
	"./spiritofivory.webp": 57579,
	"./spy.webp": 60767,
	"./steward.webp": 97958,
	"./stormcatcher.webp": 73215,
	"./summoner.webp": 85596,
	"./sweetheart.webp": 74301,
	"./tealady.webp": 91382,
	"./thief.webp": 77938,
	"./tinker.webp": 24980,
	"./tor.webp": 69685,
	"./towncrier.webp": 4622,
	"./townsfolk.webp": 6712,
	"./toymaker.webp": 22287,
	"./traveller.webp": 43411,
	"./undertaker.webp": 8222,
	"./unofficial/Alternate/acrobat.webp": 82177,
	"./unofficial/Alternate/alchemist.webp": 25081,
	"./unofficial/Alternate/alhadikhia.webp": 4951,
	"./unofficial/Alternate/alsaahir.webp": 46874,
	"./unofficial/Alternate/amnesiac.webp": 87583,
	"./unofficial/Alternate/apprentice_e.webp": 29037,
	"./unofficial/Alternate/apprentice_g.webp": 16385,
	"./unofficial/Alternate/artist.webp": 11724,
	"./unofficial/Alternate/assassin.webp": 49407,
	"./unofficial/Alternate/atheist.webp": 85877,
	"./unofficial/Alternate/balloonist.webp": 4058,
	"./unofficial/Alternate/banshee.webp": 45257,
	"./unofficial/Alternate/barber.webp": 92531,
	"./unofficial/Alternate/barista_e.webp": 75211,
	"./unofficial/Alternate/barista_g.webp": 53274,
	"./unofficial/Alternate/baron.webp": 78335,
	"./unofficial/Alternate/beggar_e.webp": 94113,
	"./unofficial/Alternate/beggar_g.webp": 84441,
	"./unofficial/Alternate/bishop_e.webp": 74734,
	"./unofficial/Alternate/bishop_g.webp": 45060,
	"./unofficial/Alternate/boffin.webp": 82186,
	"./unofficial/Alternate/bonecollector_e.webp": 72182,
	"./unofficial/Alternate/bonecollector_g.webp": 79438,
	"./unofficial/Alternate/boomdandy.webp": 62065,
	"./unofficial/Alternate/bountyhunter.webp": 83299,
	"./unofficial/Alternate/bureaucrat_e.webp": 87526,
	"./unofficial/Alternate/bureaucrat_g.webp": 40016,
	"./unofficial/Alternate/butcher_e.webp": 50105,
	"./unofficial/Alternate/butcher_g.webp": 35258,
	"./unofficial/Alternate/butler.webp": 16482,
	"./unofficial/Alternate/cacklejack_e.webp": 36647,
	"./unofficial/Alternate/cacklejack_g.webp": 17838,
	"./unofficial/Alternate/cannibal.webp": 46621,
	"./unofficial/Alternate/cerenovus.webp": 92587,
	"./unofficial/Alternate/chambermaid.webp": 50146,
	"./unofficial/Alternate/chef.webp": 97830,
	"./unofficial/Alternate/choirboy.webp": 36281,
	"./unofficial/Alternate/clockmaker.webp": 3472,
	"./unofficial/Alternate/courtier.webp": 81221,
	"./unofficial/Alternate/cultleader.webp": 60274,
	"./unofficial/Alternate/damsel.webp": 63945,
	"./unofficial/Alternate/demon.webp": 97009,
	"./unofficial/Alternate/deviant_e.webp": 37859,
	"./unofficial/Alternate/deviant_g.webp": 8461,
	"./unofficial/Alternate/devilsadvocate.webp": 23675,
	"./unofficial/Alternate/dreamer.webp": 6277,
	"./unofficial/Alternate/drunk.webp": 94118,
	"./unofficial/Alternate/empath.webp": 60620,
	"./unofficial/Alternate/engineer.webp": 29717,
	"./unofficial/Alternate/eviltwin.webp": 37151,
	"./unofficial/Alternate/exorcist.webp": 81827,
	"./unofficial/Alternate/fanggu.webp": 32714,
	"./unofficial/Alternate/farmer.webp": 41441,
	"./unofficial/Alternate/fearmonger.webp": 90946,
	"./unofficial/Alternate/fisherman.webp": 68125,
	"./unofficial/Alternate/flowergirl.webp": 2198,
	"./unofficial/Alternate/fool.webp": 61835,
	"./unofficial/Alternate/fortuneteller.webp": 51876,
	"./unofficial/Alternate/gambler.webp": 60563,
	"./unofficial/Alternate/gangster_e.webp": 15799,
	"./unofficial/Alternate/gangster_g.webp": 70976,
	"./unofficial/Alternate/general.webp": 47326,
	"./unofficial/Alternate/gnome_e.webp": 3220,
	"./unofficial/Alternate/gnome_g.webp": 23846,
	"./unofficial/Alternate/goblin.webp": 92162,
	"./unofficial/Alternate/godfather.webp": 69598,
	"./unofficial/Alternate/golem.webp": 83668,
	"./unofficial/Alternate/goon.webp": 18788,
	"./unofficial/Alternate/gossip.webp": 57328,
	"./unofficial/Alternate/grandmother.webp": 6404,
	"./unofficial/Alternate/gunslinger_e.webp": 77192,
	"./unofficial/Alternate/gunslinger_g.webp": 24785,
	"./unofficial/Alternate/harlot_e.webp": 4889,
	"./unofficial/Alternate/harlot_g.webp": 63223,
	"./unofficial/Alternate/harpy.webp": 26095,
	"./unofficial/Alternate/hatter.webp": 23946,
	"./unofficial/Alternate/heretic.webp": 94939,
	"./unofficial/Alternate/hermit.webp": 42030,
	"./unofficial/Alternate/highpriestess.webp": 26606,
	"./unofficial/Alternate/huntsman.webp": 47422,
	"./unofficial/Alternate/imp.webp": 88803,
	"./unofficial/Alternate/innkeeper.webp": 72501,
	"./unofficial/Alternate/investigator.webp": 61630,
	"./unofficial/Alternate/judge_e.webp": 98782,
	"./unofficial/Alternate/judge_g.webp": 64922,
	"./unofficial/Alternate/juggler.webp": 34284,
	"./unofficial/Alternate/kazali.webp": 43127,
	"./unofficial/Alternate/king.webp": 91510,
	"./unofficial/Alternate/klutz.webp": 85684,
	"./unofficial/Alternate/knight.webp": 14987,
	"./unofficial/Alternate/legion.webp": 40018,
	"./unofficial/Alternate/leviathan.webp": 5201,
	"./unofficial/Alternate/librarian.webp": 56433,
	"./unofficial/Alternate/lilmonsta.webp": 54351,
	"./unofficial/Alternate/lleech.webp": 93260,
	"./unofficial/Alternate/lordoftyphon.webp": 94531,
	"./unofficial/Alternate/lunatic.webp": 84019,
	"./unofficial/Alternate/lycanthrope.webp": 66291,
	"./unofficial/Alternate/magician.webp": 59828,
	"./unofficial/Alternate/marionette.webp": 33988,
	"./unofficial/Alternate/mastermind.webp": 81725,
	"./unofficial/Alternate/mathematician.webp": 49410,
	"./unofficial/Alternate/matron_e.webp": 13241,
	"./unofficial/Alternate/matron_g.webp": 50372,
	"./unofficial/Alternate/mayor.webp": 10211,
	"./unofficial/Alternate/mezepheles.webp": 74207,
	"./unofficial/Alternate/minion.webp": 94222,
	"./unofficial/Alternate/minstrel.webp": 82426,
	"./unofficial/Alternate/monk.webp": 54067,
	"./unofficial/Alternate/moonchild.webp": 23243,
	"./unofficial/Alternate/mutant.webp": 73140,
	"./unofficial/Alternate/nightwatchman.webp": 14914,
	"./unofficial/Alternate/noble.webp": 27283,
	"./unofficial/Alternate/nodashii.webp": 97244,
	"./unofficial/Alternate/ogre.webp": 51492,
	"./unofficial/Alternate/ojo.webp": 33696,
	"./unofficial/Alternate/oracle.webp": 54388,
	"./unofficial/Alternate/organgrinder.webp": 87328,
	"./unofficial/Alternate/outsider.webp": 24107,
	"./unofficial/Alternate/pacifist.webp": 56171,
	"./unofficial/Alternate/philosopher.webp": 65672,
	"./unofficial/Alternate/pithag.webp": 60055,
	"./unofficial/Alternate/pixie.webp": 74690,
	"./unofficial/Alternate/plaguedoctor.webp": 28710,
	"./unofficial/Alternate/po.webp": 15341,
	"./unofficial/Alternate/poisoner.webp": 90233,
	"./unofficial/Alternate/politician.webp": 39444,
	"./unofficial/Alternate/poppygrower.webp": 58148,
	"./unofficial/Alternate/preacher.webp": 7966,
	"./unofficial/Alternate/princess.webp": 83774,
	"./unofficial/Alternate/professor.webp": 4694,
	"./unofficial/Alternate/psychopath.webp": 38349,
	"./unofficial/Alternate/pukka.webp": 67527,
	"./unofficial/Alternate/puzzlemaster.webp": 92416,
	"./unofficial/Alternate/ravenkeeper.webp": 65074,
	"./unofficial/Alternate/recluse.webp": 17463,
	"./unofficial/Alternate/riot.webp": 6723,
	"./unofficial/Alternate/sage.webp": 15456,
	"./unofficial/Alternate/sailor.webp": 11796,
	"./unofficial/Alternate/saint.webp": 1090,
	"./unofficial/Alternate/savant.webp": 11122,
	"./unofficial/Alternate/scapegoat_e.webp": 64476,
	"./unofficial/Alternate/scapegoat_g.webp": 94434,
	"./unofficial/Alternate/scarletwoman.webp": 14560,
	"./unofficial/Alternate/seamstress.webp": 43258,
	"./unofficial/Alternate/shabaloth.webp": 91550,
	"./unofficial/Alternate/shugenja.webp": 98484,
	"./unofficial/Alternate/slayer.webp": 62149,
	"./unofficial/Alternate/snakecharmer.webp": 2196,
	"./unofficial/Alternate/snitch.webp": 65184,
	"./unofficial/Alternate/soldier.webp": 20463,
	"./unofficial/Alternate/spy.webp": 19918,
	"./unofficial/Alternate/steward.webp": 31244,
	"./unofficial/Alternate/summoner.webp": 19826,
	"./unofficial/Alternate/sweetheart.webp": 64386,
	"./unofficial/Alternate/tealady.webp": 60460,
	"./unofficial/Alternate/thief_e.webp": 36735,
	"./unofficial/Alternate/thief_g.webp": 97540,
	"./unofficial/Alternate/tinker.webp": 74763,
	"./unofficial/Alternate/towncrier.webp": 78615,
	"./unofficial/Alternate/townsfolk.webp": 79507,
	"./unofficial/Alternate/traveller_e.webp": 26361,
	"./unofficial/Alternate/traveller_g.webp": 12499,
	"./unofficial/Alternate/undertaker.webp": 10553,
	"./unofficial/Alternate/vigormortis.webp": 97867,
	"./unofficial/Alternate/villageidiot.webp": 99474,
	"./unofficial/Alternate/virgin.webp": 78644,
	"./unofficial/Alternate/vizier.webp": 41063,
	"./unofficial/Alternate/vortox.webp": 65022,
	"./unofficial/Alternate/voudon_e.webp": 69965,
	"./unofficial/Alternate/voudon_g.webp": 24960,
	"./unofficial/Alternate/washerwoman.webp": 74481,
	"./unofficial/Alternate/widow.webp": 85287,
	"./unofficial/Alternate/witch.webp": 66518,
	"./unofficial/Alternate/wizard.webp": 64735,
	"./unofficial/Alternate/wraith.webp": 70157,
	"./unofficial/Alternate/xaan.webp": 66827,
	"./unofficial/Alternate/yaggababble.webp": 85760,
	"./unofficial/Alternate/zealot.webp": 13592,
	"./unofficial/Alternate/zombuul.webp": 63201,
	"./unofficial/acrobat.webp": 1917,
	"./unofficial/alchemist.webp": 57651,
	"./unofficial/alhadikhia.webp": 68362,
	"./unofficial/alsaahir.webp": 49678,
	"./unofficial/amnesiac.webp": 18751,
	"./unofficial/angel.webp": 2390,
	"./unofficial/apprentice.webp": 82686,
	"./unofficial/artist.webp": 42277,
	"./unofficial/assassin.webp": 79606,
	"./unofficial/atheist.webp": 52445,
	"./unofficial/balloonist.webp": 49857,
	"./unofficial/banshee.webp": 69176,
	"./unofficial/barber.webp": 31313,
	"./unofficial/barista.webp": 53268,
	"./unofficial/baron.webp": 76199,
	"./unofficial/beggar.webp": 55879,
	"./unofficial/bigwig.webp": 19329,
	"./unofficial/bishop.webp": 37074,
	"./unofficial/boffin.webp": 31777,
	"./unofficial/bonecollector.webp": 49147,
	"./unofficial/boomdandy.webp": 78241,
	"./unofficial/bootlegger.webp": 38858,
	"./unofficial/bountyhunter.webp": 9146,
	"./unofficial/buddhist.webp": 35731,
	"./unofficial/bureaucrat.webp": 69225,
	"./unofficial/butcher.webp": 96732,
	"./unofficial/butler.webp": 54303,
	"./unofficial/cacklejack.webp": 79716,
	"./unofficial/cannibal.webp": 42132,
	"./unofficial/cerenovus.webp": 45032,
	"./unofficial/chambermaid.webp": 47445,
	"./unofficial/chef.webp": 83131,
	"./unofficial/choirboy.webp": 66951,
	"./unofficial/clockmaker.webp": 46073,
	"./unofficial/courtier.webp": 30928,
	"./unofficial/cultleader.webp": 51757,
	"./unofficial/custom.webp": 50906,
	"./unofficial/damsel.webp": 69285,
	"./unofficial/demon.webp": 45695,
	"./unofficial/deusexfiasco.webp": 81613,
	"./unofficial/deviant.webp": 49483,
	"./unofficial/devilsadvocate.webp": 58695,
	"./unofficial/djinn.webp": 49518,
	"./unofficial/doomsayer.webp": 20252,
	"./unofficial/dreamer.webp": 24867,
	"./unofficial/drunk.webp": 79378,
	"./unofficial/duchess.webp": 6199,
	"./unofficial/empath.webp": 39484,
	"./unofficial/engineer.webp": 75784,
	"./unofficial/evil.webp": 80267,
	"./unofficial/eviltwin.webp": 71181,
	"./unofficial/exorcist.webp": 77695,
	"./unofficial/fabled.webp": 4564,
	"./unofficial/fanggu.webp": 31436,
	"./unofficial/farmer.webp": 50477,
	"./unofficial/fearmonger.webp": 13364,
	"./unofficial/ferryman.webp": 77547,
	"./unofficial/fibbin.webp": 80588,
	"./unofficial/fiddler.webp": 1927,
	"./unofficial/fisherman.webp": 8901,
	"./unofficial/flowergirl.webp": 67064,
	"./unofficial/fool.webp": 89506,
	"./unofficial/fortuneteller.webp": 5249,
	"./unofficial/gambler.webp": 2526,
	"./unofficial/gangster.webp": 85702,
	"./unofficial/gardener.webp": 85606,
	"./unofficial/general.webp": 7829,
	"./unofficial/gnome.webp": 1804,
	"./unofficial/goblin.webp": 87217,
	"./unofficial/godfather.webp": 36367,
	"./unofficial/godofug.webp": 35515,
	"./unofficial/golem.webp": 89074,
	"./unofficial/good.webp": 31158,
	"./unofficial/goon.webp": 71295,
	"./unofficial/gossip.webp": 16631,
	"./unofficial/grandmother.webp": 42322,
	"./unofficial/gunslinger.webp": 8217,
	"./unofficial/harlot.webp": 87881,
	"./unofficial/harpy.webp": 12463,
	"./unofficial/hatter.webp": 58722,
	"./unofficial/hellslibrarian.webp": 69046,
	"./unofficial/heretic.webp": 68732,
	"./unofficial/hermit.webp": 95587,
	"./unofficial/highpriestess.webp": 88202,
	"./unofficial/hindu.webp": 5949,
	"./unofficial/huntsman.webp": 30037,
	"./unofficial/imp.webp": 46605,
	"./unofficial/innkeeper.webp": 10854,
	"./unofficial/investigator.webp": 13277,
	"./unofficial/judge.webp": 14265,
	"./unofficial/juggler.webp": 63523,
	"./unofficial/kazali.webp": 33929,
	"./unofficial/king.webp": 61697,
	"./unofficial/klutz.webp": 59507,
	"./unofficial/knaves.webp": 54479,
	"./unofficial/knight.webp": 38831,
	"./unofficial/legion.webp": 42070,
	"./unofficial/leviathan.webp": 54050,
	"./unofficial/librarian.webp": 5771,
	"./unofficial/lilmonsta.webp": 70797,
	"./unofficial/lleech.webp": 47526,
	"./unofficial/lordoftyphon.webp": 45347,
	"./unofficial/loric.webp": 83841,
	"./unofficial/lunatic.webp": 82257,
	"./unofficial/lycanthrope.webp": 52403,
	"./unofficial/magician.webp": 7814,
	"./unofficial/marionette.webp": 92331,
	"./unofficial/mastermind.webp": 35162,
	"./unofficial/mathematician.webp": 32205,
	"./unofficial/matron.webp": 71459,
	"./unofficial/mayor.webp": 44268,
	"./unofficial/mezepheles.webp": 87330,
	"./unofficial/minion.webp": 5209,
	"./unofficial/minstrel.webp": 25946,
	"./unofficial/monk.webp": 20499,
	"./unofficial/moonchild.webp": 97237,
	"./unofficial/mutant.webp": 2156,
	"./unofficial/nightwatchman.webp": 71407,
	"./unofficial/noble.webp": 30330,
	"./unofficial/nodashii.webp": 30495,
	"./unofficial/ogre.webp": 71588,
	"./unofficial/ojo.webp": 88986,
	"./unofficial/oracle.webp": 59653,
	"./unofficial/organgrinder.webp": 46208,
	"./unofficial/outsider.webp": 40879,
	"./unofficial/pacifist.webp": 40550,
	"./unofficial/philosopher.webp": 49457,
	"./unofficial/pithag.webp": 33588,
	"./unofficial/pixie.webp": 4558,
	"./unofficial/plaguedoctor.webp": 77191,
	"./unofficial/po.webp": 48256,
	"./unofficial/poisoner.webp": 85096,
	"./unofficial/politician.webp": 91156,
	"./unofficial/pope.webp": 56366,
	"./unofficial/poppygrower.webp": 10420,
	"./unofficial/preacher.webp": 92930,
	"./unofficial/princess.webp": 35699,
	"./unofficial/professor.webp": 12114,
	"./unofficial/psychopath.webp": 60001,
	"./unofficial/pukka.webp": 84679,
	"./unofficial/puzzlemaster.webp": 63216,
	"./unofficial/ravenkeeper.webp": 30671,
	"./unofficial/recluse.webp": 67089,
	"./unofficial/revolutionary.webp": 58757,
	"./unofficial/riot.webp": 68238,
	"./unofficial/sage.webp": 87539,
	"./unofficial/sailor.webp": 86899,
	"./unofficial/saint.webp": 52603,
	"./unofficial/savant.webp": 33725,
	"./unofficial/scapegoat.webp": 21829,
	"./unofficial/scarletwoman.webp": 70800,
	"./unofficial/seamstress.webp": 10435,
	"./unofficial/sentinel.webp": 21401,
	"./unofficial/shabaloth.webp": 19129,
	"./unofficial/shugenja.webp": 5363,
	"./unofficial/slayer.webp": 81142,
	"./unofficial/snakecharmer.webp": 77560,
	"./unofficial/snitch.webp": 7456,
	"./unofficial/soldier.webp": 51790,
	"./unofficial/spiritofivory.webp": 55951,
	"./unofficial/spy.webp": 48602,
	"./unofficial/steward.webp": 76865,
	"./unofficial/stormcatcher.webp": 79367,
	"./unofficial/summoner.webp": 71747,
	"./unofficial/sweetheart.webp": 53821,
	"./unofficial/tealady.webp": 54787,
	"./unofficial/thief.webp": 22332,
	"./unofficial/tinker.webp": 90623,
	"./unofficial/tor.webp": 74771,
	"./unofficial/towncrier.webp": 79709,
	"./unofficial/townsfolk.webp": 66482,
	"./unofficial/toymaker.webp": 57393,
	"./unofficial/traveller.webp": 57578,
	"./unofficial/undertaker.webp": 34633,
	"./unofficial/ventriloquist.webp": 49806,
	"./unofficial/vigormortis.webp": 61297,
	"./unofficial/villageidiot.webp": 66744,
	"./unofficial/virgin.webp": 48317,
	"./unofficial/vizier.webp": 14826,
	"./unofficial/vortox.webp": 21607,
	"./unofficial/voudon.webp": 87711,
	"./unofficial/washerwoman.webp": 11169,
	"./unofficial/widow.webp": 10969,
	"./unofficial/witch.webp": 32912,
	"./unofficial/wizard.webp": 760,
	"./unofficial/wraith.webp": 63079,
	"./unofficial/xaan.webp": 48812,
	"./unofficial/yaggababble.webp": 79947,
	"./unofficial/zealot.webp": 17108,
	"./unofficial/zenomancer.webp": 90339,
	"./unofficial/zombuul.webp": 23516,
	"./ventriloquist.webp": 76824,
	"./vigormortis.webp": 61151,
	"./villageidiot.webp": 53348,
	"./virgin.webp": 34932,
	"./vizier.webp": 35226,
	"./vortox.webp": 63358,
	"./voudon.webp": 68578,
	"./washerwoman.webp": 53338,
	"./widow.webp": 28090,
	"./witch.webp": 24274,
	"./wizard.webp": 20789,
	"./wraith.webp": 39903,
	"./xaan.webp": 117,
	"./yaggababble.webp": 46774,
	"./zealot.webp": 84982,
	"./zenomancer.webp": 88513,
	"./zombuul.webp": 99040
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31654;